// src/utils/dateUtils.js

/**
 * Formats a date string to 'en-US' locale.
 * @param {string | Date} date - The date string or Date object to format.
 * @returns {string} The formatted date string.
 */
export const formatDate = (date: any) => {
    if (!date) return ''

    const dateObj = typeof date === 'string' ? new Date(date) : date
    return dateObj.toLocaleDateString('en-US')
}

export const formatDateAndTime = (date: any) => {
    if (!date) return ''

    const dateObj = typeof date === 'string' ? new Date(date + 'Z') : date // Appending 'Z' treats the date as UTC
    const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true, // Ensures 12-hour format
    }

    return dateObj.toLocaleString(undefined, options)
}

export const formatDateToLong = (dateString: string): string => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    })
}

export function normalizeLink(inputLink: string) {
    const normalizedLink = inputLink.trim().toLowerCase()
    const urlPattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9-]+(\/[^\s]*)?$/i
    if (urlPattern.test(normalizedLink) && normalizedLink.startsWith('http')) {
        // Link is valid and already has http:// or https://, so do nothing
        return normalizedLink
    } else {
        // Handle invalid link cases (add https://, www, .com if needed)
        let formattedLink = normalizedLink
        if (!formattedLink.startsWith('http')) {
            formattedLink = 'https://' + formattedLink // Add https if missing
        }
        if (!formattedLink.includes('www.')) {
            formattedLink = formattedLink.replace(
                /^https?:\/\//,
                'https://www.'
            ) // Add www
        }
        return formattedLink
    }
}
